import React from 'react';

import { Path, Svg } from './styles';
import { IconProps } from './types';

const path = [
  'M7.48793 8.06037V2.57599L10.2301 5.31818L7.48793 8.06037ZM0',
  '5.81676V0H0.997159V5.81676H0ZM0.0276989 5.81676V4.8196H8.32812V5.81676H0.0276989Z',
].join(' ');

export const IconError = ({ width = 11, height = 9, color = '#DC0030', className }: IconProps) => (
  <Svg className={className} width={width} height={height} viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <Path d={path} fill={color} />
  </Svg>
);

export default IconError;
